import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActiveCartService } from '@spartacus/cart/base/core';
import { LaunchDialogService } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { KnBrDraftOrdersService } from 'src/app/store/kn-br-draft-orders/kn-br-draft-orders.service';

import { KnBrCartContextService } from '../../../../store/kn-br-cart-context/kn-br-cart-context.service';
import { KnBrQuoteContextService } from '../../../../store/kn-br-quote-context/kn-br-quote-context.service';
import { KnBrQuoteEntryService } from '../../../../store/kn-br-quote-entry/kn-br-quote-entry.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';

@Component({
    selector: 'knbr-kn-br-product-quick-entry-popup',
    templateUrl: './kn-br-product-quick-entry-popup.component.html',
    styleUrls: ['./kn-br-product-quick-entry-popup.component.scss'],
    imports: [ReactiveFormsModule, FormsModule, AsyncPipe, TranslatePipe]
})
export class KnBrProductQuickEntryPopupComponent implements OnInit, OnDestroy {
  productNo: string;
  isDisabled = true;
  modalRef: any;
  isCartContext = false;
  isQuoteContext = false;
  subscriptions = new Subscription();
  isSaveDisabled$: Observable<boolean> = this.knBrQuotEntryService.isSaveDisabled$;
  constructor(
    protected modalService: NgbModal,
    private knBrQuotEntryService: KnBrQuoteEntryService,
    private activeCartService: ActiveCartService,
    private knBrQuoteContextService: KnBrQuoteContextService,
    private knBrCartContextService: KnBrCartContextService,
    protected knBrDraftOrdersService: KnBrDraftOrdersService
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.knBrQuoteContextService.get$.subscribe((value) => {
        if (value) {
          this.isQuoteContext = true;
          this.isCartContext = false;
        }
      })
    );

    this.subscriptions.add(
      this.knBrCartContextService.get$.subscribe((value) => {
        if (value) {
          this.isCartContext = true;
          this.isQuoteContext = false;
        }
      })
    );
  }

  save() {
    const productNo = this.prepareMaterialArray(this.productNo);
    const quoteEntry = {
      code: productNo.toString(),
      quantity: 1,
    };
    if (this.isQuoteContext) {
      this.knBrQuotEntryService.add(quoteEntry);
    }
    if (this.isCartContext) {
      this.knBrDraftOrdersService.setAddCartEntryLoading(true);
      this.activeCartService.addEntry(productNo.toString(), 1);
    }
    this.dismissModal();
  }

  prepareMaterialArray(materialNumbers: string) {
    const material = [];
    const splitMaterialNumbers = materialNumbers.split('\n').join(',').split(',');
    const filteredMaterialBumbers = splitMaterialNumbers.filter((el) => {
      return el !== '';
    });
    filteredMaterialBumbers.forEach((element) => {
      material.push(element.trim());
    });
    return material;
  }

  onChange(value) {
    if (value.length < 1) {
      this.isDisabled = true;
    } else {
      this.isDisabled = false;
    }
  }

  dismissModal(reason?: any): void {
    this.modalService.dismissAll(reason);
  }
  ngOnDestroy(): void {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    this.subscriptions.unsubscribe();
  }
}
